/*
 *   Menti-display (Mentimeter Brand Font)
 */
const light = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Light.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Light.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Light.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '300' },
};

const lightItalic = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-LightItalic.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-LightItalic.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-LightItalic.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '300', fontStyle: 'italic' },
};

const regular = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Regular.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Regular.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Regular.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '400' },
};

const regularItalic = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-RegularItalic.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-RegularItalic.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-RegularItalic.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '400', fontStyle: 'italic' },
};

const semiBold = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBold.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBold.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBold.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '600' },
};

const semiBoldItalic = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBoldItalic.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBoldItalic.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-SemiBoldItalic.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '600', fontStyle: 'italic' },
};

const bold = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Bold.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Bold.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-Bold.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '700' },
};

const boldItalic = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-BoldItalic.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-BoldItalic.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-BoldItalic.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '700', fontStyle: 'italic' },
};

const extraBold = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBold.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBold.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBold.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '800' },
};

const extraBoldItalic = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBoldItalic.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBoldItalic.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display/1.4/MentiDisplay-ExtraBoldItalic.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '800', fontStyle: 'italic' },
};

export const MentiDisplay = {
  light,
  lightItalic,
  regular,
  regularItalic,
  semiBold,
  semiBoldItalic,
  bold,
  boldItalic,
  extraBold,
  extraBoldItalic,
};

export const mentiDisplayKeys = Object.keys(MentiDisplay) as Array<
  keyof typeof MentiDisplay
>;
